<script setup>
import { useAppStore } from '@/stores/App'

const app = useAppStore()
const staticURLAdimg = useRuntimeConfig().public.staticURLAdimg

function scrollToSection(id) {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
}

useSeoMeta({
    title: 'Exclusive Offers',
    ogTitle: 'Exclusive Offers',
    description: 'satYatunes exclusive offers and discounts on Spire and SynthMaster.',
    ogDescription: 'satYatunes exclusive offers and discounts on Spire and SynthMaster.',
})
</script>
<template>
    <v-row id="offers" class="mt-4 justify-center slide-from-top align-stretch">
        <v-col cols="12" class="">
            <v-row no-gutters class="justify-center">
                <v-col cols="12" class="text-center">
                    <v-hover v-for="chip in app.offersChips" :key="chip.text" v-slot="{ isHovering, props }">
                        <v-chip
                            v-bind="props"
                            density="comfortable"
                            :color="isHovering ? 'secondary' : undefined"
                            class="mx-2 my-1 text-button font-weight-medium"
                            @click="scrollToSection(chip.section)"
                            size="large"
                            :aria-label="`Go to ${chip.section} section`"
                        >
                            {{ chip.text }}
                        </v-chip>
                    </v-hover>
                </v-col>
            </v-row>
            <v-row id="SP3CPN" class="justify-center">
                <v-col cols="10">
                    <v-img
                        id="cardImg"
                        :src="staticURLAdimg + 'afst-rs-st3percent-coupon-lg.webp'"
                        class="fade-in-left rounded"
                    >
                        <template #sources>
                            <source
                                media="(max-width: 800px)"
                                :srcset="`${staticURLAdimg}afst-rs-st3percent-coupon-xs.webp`"
                            />
                            <source
                                media="(max-width: 1280px)"
                                :srcset="`${staticURLAdimg}afst-rs-st3percent-coupon-md.webp`"
                            />
                            <source
                                media="(max-width: 1920px)"
                                :srcset="`${staticURLAdimg}afst-rs-st3percent-coupon-lg.webp`"
                            />
                            <source
                                media="(min-width: 1920px)"
                                :srcset="`${staticURLAdimg}afst-rs-st3percent-coupon-xl.webp`"
                            />
                        </template>
                        <nuxt-link
                            id="STSP3C"
                            data-adspot="top-offers"
                            data-adbrand="reveal-sound"
                            data-adtitle="Satyatunes 3 Percent Coupon"
                            to="https://reveal-sound.com"
                            target="_blank"
                            class="text-decoration-none text-grey-darken-4 aflclk"
                            aria-label="Get 3% discount on your purchase at Reveal-Sound.com"
                            rel="noopener"
                        >
                            <v-container class="fill-height align-start"> </v-container>
                        </nuxt-link>
                    </v-img>
                </v-col>
                <v-col cols="10">
                    <v-row class="justify-center">
                        <v-col cols="12" class="d-flex align-center justify-center">
                            <span class="mr-2 font-weight-medium">Share this deal:</span>
                            <social-share
                                v-for="network in ['facebook', 'x', 'reddit', 'threads', 'skype', 'whatsapp', 'email']"
                                :key="network"
                                :network="network"
                                :styled="true"
                                title="3% discount on your purchase at Reveal-Sound.com"
                                :image="staticURLAdimg + 'afst-rs-st3percent-coupon-lg.webp'"
                                class="ma-1 pa-1 text-grey"
                            >
                                <!-- <template #icon> <v-icon size="32" :icon="`mdi-${network}`"></v-icon></template> -->
                            </social-share>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="text-center">
                            <v-row>
                                <v-col>
                                    <app-button
                                        href="https://reveal-sound.com"
                                        target="_blank"
                                        :btn-text="`Get the Deal`"
                                        :prepend-icon="`mdi-gift-outline`"
                                        size="x-large"
                                        data-prodname="satyatunes-coupon"
                                        aria-label="Explore 3% discount on your purchase at Reveal-Sound.com"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="my-4 pb-0 st-header text-center">
                            3% off on Your Purchase at Reveal-Sound.com
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card variant="flat" class="st-card st-box-shadow">
                                <v-card-text class="st-card-text text-justify">
                                    Get 3% discount on your purchase at Reveal-Sound.com by using coupon code
                                    <span class="font-weight-medium text-info">satyatunes</span>, includes Spire plugin
                                    and all products in sounds store.
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card variant="flat" class="st-card st-box-shadow">
                                <v-card-text class="st-card-text text-justify">
                                    The coupon provides additional discounts on top of any ongoing promotions.
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <!-- 
                        <v-col
                            cols="12"
                            md="5"
                            class="pa-4 st-card-text text-justify bg-grey-lighten-4 rounded st-box-shadow"
                        >
                            The coupon provides additional discounts on top of any ongoing promotions. For example, 30%
                            Valentines discount is on until 01-March-2025. You can get Spire for
                            <span class="text-error font-weight-medium">$125.13 (Excludes VAT)</span>
                        </v-col> -->
                    </v-row>
                </v-col>
            </v-row>
            <v-row id="SP50CN" class="mt-16 py-16 justify-center bg-grey-darken-4 rounded">
                <v-col cols="10">
                    <v-img
                        id="cardImg"
                        :src="staticURLAdimg + 'afst-rs-stindia-coupon-lg.webp'"
                        class="fade-in-left rounded"
                    >
                        <template #sources>
                            <source
                                media="(max-width: 800px)"
                                :srcset="`${staticURLAdimg}afst-rs-stindia-coupon-xs.webp`"
                            />
                            <source
                                media="(max-width: 1280px)"
                                :srcset="`${staticURLAdimg}afst-rs-stindia-coupon-md.webp`"
                            />
                            <source
                                media="(max-width: 1920px)"
                                :srcset="`${staticURLAdimg}afst-rs-stindia-coupon-lg.webp`"
                            />
                            <source
                                media="(min-width: 1920px)"
                                :srcset="`${staticURLAdimg}afst-rs-stindia-coupon-xl.webp`"
                            />
                        </template>
                        <nuxt-link
                            data-adspot="top-offers"
                            data-adbrand="reveal-sound"
                            data-adtitle="Satyatunes India Coupon"
                            to="https://reveal-sound.com"
                            target="_blank"
                            class="text-decoration-none text-grey-darken-4 aflclk"
                            aria-label="Get 50% discount on Spire plugin and sounds"
                            rel="noopener"
                        >
                            <v-container class="fill-height align-start"> </v-container>
                        </nuxt-link>
                    </v-img>
                </v-col>
                <v-col cols="10">
                    <v-row class="justify-center">
                        <v-col cols="12" class="d-flex align-center justify-center">
                            <span class="mr-2 font-weight-medium">Share this deal:</span>
                            <social-share
                                v-for="network in ['facebook', 'x', 'reddit', 'threads', 'skype', 'whatsapp', 'email']"
                                :key="network"
                                :network="network"
                                :styled="true"
                                title="50% discount on Spire plugin and sounds for Indian customers"
                                :image="staticURLAdimg + 'afst-rs-stindia-coupon-lg.webp'"
                                class="ma-1 pa-1 text-grey rounded"
                            >
                                <!-- <template #icon> <v-icon size="32" :icon="`mdi-${network}`"></v-icon></template> -->
                            </social-share>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="text-center">
                            <v-row>
                                <v-col>
                                    <v-btn
                                        href="https://reveal-sound.com"
                                        target="_blank"
                                        text="Get the Deal"
                                        :prepend-icon="`mdi-gift-outline`"
                                        size="x-large"
                                        color="secondary"
                                        data-prodname="satyatunesindia-coupon"
                                        aria-label="Explore 50% discount on Spire plugin and sounds for Indian customers"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="mt-4 pb-0 st-header text-center">
                            50% off on Your Purchase at Reveal-Sound.com
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="mb-4 pt-0 st-subheader text-center">
                            An exclusive discount for Indian buyers
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card variant="flat" class="st-card st-box-shadow">
                                <v-card-text class="st-card-text text-justify">
                                    Indian buyers can avail 50% discount on all items in cart by using the coupon code
                                    <span class="font-weight-medium text-info">satyatunesindia</span>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card variant="flat" class="st-card st-box-shadow">
                                <v-card-text class="st-card-text text-justify">
                                    The coupon provides additional discounts on top of any ongoing promotions.
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" class="mt-2 pb-0 text-error font-weight-medium text-center">
                            Buyer must be located in India
                        </v-col>
                        <v-col cols="12" class="mt-0 pt-0 text-error font-weight-medium text-center">
                            ** Excludes 18% GST.
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row id="SM10CN" class="my-16 justify-center">
                <v-col cols="10">
                    <v-img
                        id="cardImg"
                        :src="staticURLAdimg + 'afst-kv331-st-coupon-lg.webp'"
                        class="fade-in-left rounded"
                    >
                        <template #sources>
                            <source
                                media="(max-width: 800px)"
                                :srcset="`${staticURLAdimg}afst-kv331-st-coupon-xs.webp`"
                            />
                            <source
                                media="(max-width: 1280px)"
                                :srcset="`${staticURLAdimg}afst-kv331-st-coupon-md.webp`"
                            />
                            <source
                                media="(max-width: 1920px)"
                                :srcset="`${staticURLAdimg}afst-kv331-st-coupon-lg.webp`"
                            />
                            <source
                                media="(min-width: 1920px)"
                                :srcset="`${staticURLAdimg}afst-kv331-st-coupon-xl.webp`"
                            />
                        </template>
                        <nuxt-link
                            id="STKVCN"
                            data-adspot="top-offers"
                            data-adbrand="KV331 Audio"
                            data-adtitle="Satyatunes 10 Percent Off Coupon"
                            to="https://www.synthmaster.com/index.aspx?couponcode=satyatunes"
                            target="_blank"
                            class="text-decoration-none text-grey-darken-4 aflclk"
                            aria-label="Get 10% discount on your purchase at synthmaster.com"
                            rel="noopener"
                        >
                            <v-container class="fill-height align-start"> </v-container>
                        </nuxt-link>
                    </v-img>
                </v-col>
                <v-col cols="10" class="mb-16">
                    <v-row class="justify-center">
                        <v-col cols="12" class="d-flex align-center justify-center">
                            <span class="mr-2 font-weight-medium">Share this deal:</span>
                            <social-share
                                v-for="network in ['facebook', 'x', 'reddit', 'threads', 'skype', 'whatsapp', 'email']"
                                :key="network"
                                :network="network"
                                :styled="true"
                                :label="false"
                                title="Get 10% discount on SynthMaster and Expansions"
                                :image="staticURLAdimg + 'afst-kv331-st-coupon-lg.webp'"
                                class="ma-1 pa-1 text-grey"
                            >
                                <!-- <template #icon> <v-icon size="32" :icon="`mdi-${network}`"></v-icon></template> -->
                            </social-share>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="text-center">
                            <v-row>
                                <v-col>
                                    <app-button
                                        href="https://www.synthmaster.com/index.aspx?couponcode=satyatunes"
                                        target="_blank"
                                        :btn-text="`Get the Deal`"
                                        :prepend-icon="`mdi-gift-outline`"
                                        size="x-large"
                                        data-prodname="satyatunes-coupon"
                                        aria-label="Get 10% discount on your purchase at synthmaster.com"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="my-4 pb-0 st-header">
                            10% off on Your Purchase at SynthMaster.com
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card variant="flat" class="st-card st-box-shadow">
                                <v-card-text class="st-card-text text-justify">
                                    Get 10% on your purchase at synthmaster.com by using the coupon code
                                    <span class="font-weight-medium text-info">satyatunes</span>. Includes SynthMaster
                                    3, One, Player, Expansions and Upgrades.
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card variant="flat" class="st-card st-box-shadow">
                                <v-card-text class="st-card-text text-justify">
                                    The coupon provides additional discounts on top of any ongoing promotions.
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>
